import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSpeachToText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSpeachToText"><Path d="M12.5 13.5V11.5H17M21.5 13.5V11.5H17M17 11.5V20.5M17 20.5H15.5M17 20.5H18.5" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 8.5V11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 3.5V16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 6.5V13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 4.5V9" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSpeachToText;
